import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductFilterModel, ProductModel, ProductServiceProxy, SubscriptionFilter } from '../../../../shared/service-proxies/event-service-proxy';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { DateLocaleService } from '../../../services/date-locale/date-locale.service';

@Component({
    selector: 'app-filter-account',
    templateUrl: './filter-account.component.html',
    styleUrl: './filter-account.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class FilterAccountComponent implements OnInit {
  @Input() subscriptionsFilter: SubscriptionFilter = new SubscriptionFilter();

  @Output() activeFiltersCount = new EventEmitter<number>(); 

  public productFilter: ProductFilterModel = new ProductFilterModel();
  public products: ProductModel[] = [];

  selectedProducts: string | null = null;

  dateRangeActivated: { startDate: Date; endDate: Date } = { startDate: null, endDate: null };
  dateRangeExpires: { startDate: Date; endDate: Date } = { startDate: null, endDate: null };
  dateRangelastSeen: { startDate: Date; endDate: Date } = { startDate: null, endDate: null };

  constructor(private _productServiceProxy: ProductServiceProxy, private destroyService: DestroyService, public dateLocaleService: DateLocaleService) { }
  
  ngOnInit(): void {
    this.getProducts();
    this.initializeFilters();
  } 

 initializeFilters() {
    this.dateRangeActivated = {
      startDate: this.subscriptionsFilter.activatedFrom ? new Date(this.subscriptionsFilter.activatedFrom) : null,
      endDate: this.subscriptionsFilter.activatedTo ? new Date(this.subscriptionsFilter.activatedTo) : null
    };
   this.dateRangeExpires = {
      startDate: this.subscriptionsFilter.expiresFrom ? new Date(this.subscriptionsFilter.expiresFrom) : null,
      endDate: this.subscriptionsFilter.expiresTo ? new Date(this.subscriptionsFilter.expiresTo) : null
   };
   this.dateRangelastSeen = {
      startDate: this.subscriptionsFilter.lastSeenFrom ? new Date(this.subscriptionsFilter.lastSeenFrom) : null,
      endDate: this.subscriptionsFilter.lastSeenTo ? new Date(this.subscriptionsFilter.lastSeenTo) : null
    };
}
  onDateChange(event: { startDate: Date; endDate: Date }, filter: any, fieldFrom: string, fieldTo: string) {
    filter[fieldFrom] = event.startDate || undefined;
    filter[fieldTo] = event.endDate || undefined;
  }

  getProducts() {
    this._productServiceProxy.getByFilter(this.productFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.products = res.items;
      });
  }

  onSelectChange(selected: string | null = null, filterArray: string = '') {
    if (!selected) {
      this.subscriptionsFilter[filterArray] = [];
      return;
    }
    if (!this.subscriptionsFilter[filterArray]) {
      this.subscriptionsFilter[filterArray] = [];
    }
    
    this.subscriptionsFilter[filterArray].push(selected);
  }

}

